var _style, _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiguresLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1301.1 254",
    style: {
      enableBackground: "new 0 0 1301.1 254"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.25;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1301.1,11.2C1285.8,4.6,1268.8,1,1251,1c-70.2,0-126.1,56.2-125.9,126.5c0.1,69.2,56.8,125.5,126.5,125.5 c18.4,0,33.8-2.6,49.5-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M521.4,1c-69.7,0-126.3,56.3-126.3,126c0,69.5,56.6,126,126.3,126h419.3c69.7,0,126.3-56.3,126.3-126 c0-69.5-56.5-126-126.3-126H521.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.1,59c-30.2-0.4-75.1-0.4-115.5-0.3c-21.5,0-41.8,0.1-57.9,0 M336.7,87.6c0-21.6,0.1-43.3,0.3-65.3v-1.2 l0,0c0-4.1-0.6-7.6-2.1-10.5s-3.8-5.3-7.3-7.3l0,0c-3.6-2.1-6.9-2.6-10.1-2s-6.4,2.2-9.5,4.6C301.2,11,294.4,16,287.6,21 c-12.1,8.9-24.2,17.8-36,26.9C241,56.1,229.8,59.3,216.1,59 M336.7,87.6l-1.2,131.6c0,17.6-14.2,32.1-31.8,32.1H33.3 c-17.6,0-31.9-14.4-31.8-32l0,0V90.9c0-17.3,13.5-31.3,30.4-32.1l10.8-0.1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1301.1,242.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1301.1,242.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1311.5,237.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguresLogin);
export default __webpack_public_path__ + "static/media/figures-login.5e492a024f204166082616a3eb9bf97c.svg";
export { ForwardRef as ReactComponent };